"use strict";

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _createSuper = require("/app/node_modules/@babel/runtime/helpers/createSuper.js").default;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.typed-array.uint32-array.js");

require("core-js/modules/es.array.fill.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BLAKE2 = exports.SIGMA = void 0;

var utils_js_1 = require("./utils.js"); // prettier-ignore


exports.SIGMA = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, // For BLAKE2b, the two extra permutations for rounds 10 and 11 are SIGMA[10..11] = SIGMA[0..1].
0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3]);

var BLAKE2 = /*#__PURE__*/function (_utils_js_1$Hash) {
  _inherits(BLAKE2, _utils_js_1$Hash);

  var _super = _createSuper(BLAKE2);

  function BLAKE2(blockLen, outputLen) {
    var _this;

    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var keyLen = arguments.length > 3 ? arguments[3] : undefined;
    var saltLen = arguments.length > 4 ? arguments[4] : undefined;
    var persLen = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, BLAKE2);

    _this = _super.call(this);
    _this.blockLen = blockLen;
    _this.outputLen = outputLen;
    _this.length = 0;
    _this.pos = 0;
    _this.finished = false;
    _this.destroyed = false;
    (0, utils_js_1.assertNumber)(blockLen);
    (0, utils_js_1.assertNumber)(outputLen);
    (0, utils_js_1.assertNumber)(keyLen);
    if (outputLen < 0 || outputLen > keyLen) throw new Error('Blake2: outputLen bigger than keyLen');
    if (opts.key !== undefined && (opts.key.length < 1 || opts.key.length > keyLen)) throw new Error("Key should be up 1..".concat(keyLen, " byte long or undefined"));
    if (opts.salt !== undefined && opts.salt.length !== saltLen) throw new Error("Salt should be ".concat(saltLen, " byte long or undefined"));
    if (opts.personalization !== undefined && opts.personalization.length !== persLen) throw new Error("Personalization should be ".concat(persLen, " byte long or undefined"));
    _this.buffer32 = (0, utils_js_1.u32)(_this.buffer = new Uint8Array(blockLen));
    return _this;
  }

  _createClass(BLAKE2, [{
    key: "update",
    value: function update(data) {
      if (this.destroyed) throw new Error('instance is destroyed'); // Main difference with other hashes: there is flag for last block,
      // so we cannot process current block before we know that there
      // is the next one. This significantly complicates logic and reduces ability
      // to do zero-copy processing

      var finished = this.finished,
          blockLen = this.blockLen,
          buffer = this.buffer,
          buffer32 = this.buffer32;
      if (finished) throw new Error('digest() was already called');
      data = (0, utils_js_1.toBytes)(data);
      var len = data.length;

      for (var pos = 0; pos < len;) {
        // If buffer is full and we still have input (don't process last block, same as blake2s)
        if (this.pos === blockLen) {
          this.compress(buffer32, 0, false);
          this.pos = 0;
        }

        var take = Math.min(blockLen - this.pos, len - pos);
        var dataOffset = data.byteOffset + pos; // full block && aligned to 4 bytes && not last in input

        if (take === blockLen && !(dataOffset % 4) && pos + take < len) {
          var data32 = new Uint32Array(data.buffer, dataOffset, Math.floor((len - pos) / 4));

          for (var pos32 = 0; pos + blockLen < len; pos32 += buffer32.length, pos += blockLen) {
            this.length += blockLen;
            this.compress(data32, pos32, false);
          }

          continue;
        }

        buffer.set(data.subarray(pos, pos + take), this.pos);
        this.pos += take;
        this.length += take;
        pos += take;
      }

      return this;
    }
  }, {
    key: "digestInto",
    value: function digestInto(out) {
      if (this.destroyed) throw new Error('instance is destroyed');
      if (!(out instanceof Uint8Array) || out.length < this.outputLen) throw new Error('_Blake2: Invalid output buffer');
      var finished = this.finished,
          pos = this.pos,
          buffer32 = this.buffer32;
      if (finished) throw new Error('digest() was already called');
      this.finished = true; // Padding

      this.buffer.subarray(pos).fill(0);
      this.compress(buffer32, 0, true);
      var out32 = (0, utils_js_1.u32)(out);
      this.get().forEach(function (v, i) {
        return out32[i] = v;
      });
    }
  }, {
    key: "digest",
    value: function digest() {
      var buffer = this.buffer,
          outputLen = this.outputLen;
      this.digestInto(buffer);
      var res = buffer.slice(0, outputLen);
      this.destroy();
      return res;
    }
  }, {
    key: "_cloneInto",
    value: function _cloneInto(to) {
      var _to;

      var buffer = this.buffer,
          length = this.length,
          finished = this.finished,
          destroyed = this.destroyed,
          outputLen = this.outputLen,
          pos = this.pos;
      to || (to = new this.constructor({
        dkLen: outputLen
      }));

      (_to = to).set.apply(_to, _toConsumableArray(this.get()));

      to.length = length;
      to.finished = finished;
      to.destroyed = destroyed;
      to.outputLen = outputLen;
      to.buffer.set(buffer);
      to.pos = pos;
      return to;
    }
  }]);

  return BLAKE2;
}(utils_js_1.Hash);

exports.BLAKE2 = BLAKE2;